import React, { createContext, useContext, useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Chartcontext from "../../Context/Chartcontext";
import {
  // getActivityLogData,
  getChartDetails,
  getMasterData,
} from "../../services/chartService";
import role from "../../utils/role";
import AuthContext from "../Auth/Middleware/AuthContext";
import ActivityLogs from "./ActivityLogs";
import ChartComments from "./ChartComments";
import ChartForm from "./ChartForm";
import ChartUsers from "./ChartUsers";
import NewChart from "./NewChart";
import TimeTracker from "./TimeTracker";
import Timer from "./Timer";
import ShareForReviewModal from "./ShareForReviewModal";

const EnabledContext = createContext(false);

function ChartDetails(props) {
  const { id } = useParams();
  const navigateStateGlobal = useLocation();
  const [enabled, setEnabled] = useState(false);
  const [chartData, setChartData] = useState([]);
  const [reRenderChart, setReRenderChart] = useState(false);
  const [reRenderTimer, setReRenderTimer] = useState(false);
  const [isLoading, setLoadingState] = useState(true);
  const Chartform = useContext(Chartcontext);
  const [enableUserEdit, setEnableUserEdit] = useState(null);
  const [showShareForReviewModal, setShowShareForReviewModal] = useState(false);
  const [auditors, setAuditors] = useState([]);
  const auth = useContext(AuthContext);
  const navigate = useNavigate();
  let chartIdMap = [];

  try {
    chartIdMap = JSON.parse(localStorage.getItem("chartIdMap")) || [];
  } catch (error) {
    console.log(error);
  }

  const handleHideShareForReviewModal = () => {
    setShowShareForReviewModal(false);
  }
  const handleNext = () => {
    const currentIndex = chartIdMap.findIndex(
      (idx) => idx === parseInt(id, 10),
    );
    if (currentIndex < chartIdMap.length - 1) {
      const index1 = currentIndex + 1;
      const nextId = chartIdMap[index1];
      navigate(`/process-chart/${nextId}`);
    } else {
      navigate("/");
    }
  };

  const handlePrevious = () => {
    const currentIndex = chartIdMap.findIndex(
      (idx) => idx === parseInt(id, 10),
    );
    if (currentIndex < chartIdMap.length - 1) {
      const index1 = currentIndex - 1;
      const prevId = chartIdMap[index1];
      if (prevId) {
        navigate(`/process-chart/${prevId}`);
      } else {
        navigate("/");
      }
    }
  };

  const showLogin = (e) => {
    e.preventDefault();
    fetch(`${process.env.REACT_APP_API_HOST}/charts/${id}`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      },
      mode: "cors",
      body: JSON.stringify(Chartform.inpval),
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    fetchRecord(id);
    // fetchActivityLogs(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reRenderTimer, Chartform?.flagChange, navigateStateGlobal]);

  // const fetchActivityLogs = async () => {
  //   getActivityLogData(id)
  //     .then((response) => {
  //       Chartform.setActivityLogs(response.data);
  //     })

  //     .catch((error) => {
  //       console.log(error);
  //     });
  // };

  const fetchRecord = async () => {
    try {
      setLoadingState(true);
      let response = await getChartDetails(id);
      if (response.success) {
        setChartData(response.data);
        setEnableUserEdit(response.data?.UserId);
        let storeData = window.localStorage.getItem("timerData") ?? "{}";
        storeData = JSON.parse(storeData);
        if (response?.data?.timer) {
          storeData[id] = {
            startTime: new Date(response?.data?.timer).getTime(),
          };
        } else {
          storeData[id] = {};
        }
        window.localStorage.setItem("timerData", JSON.stringify(storeData));
        const chartResponse = response.data;
        Chartform.setInputval({
          admit_date: chartResponse?.AdmitDate,
          chart_no: chartResponse?.ChartNo,
          coder_comments: chartResponse?.CoderComments,
          date_of_completion: chartResponse?.DateOfCompletion,
          date_of_service: chartResponse?.DateOfService,
          discharge_date: chartResponse?.DischargeDate,
          em: chartResponse?.Em,
          mr_no: chartResponse?.MR_No,
          primary_diagnosis: chartResponse?.PrimaryDiagnosis,
          next_user_id: chartResponse?.next_user_id,
          poa: chartResponse?.poa,
          los: chartResponse?.los,
          drg_value: chartResponse?.drg_value,
          procedure_code: chartResponse?.procedure_code,
          denial_comments: chartResponse?.DenialComments,
          ResponsibleParties: chartResponse?.ResponsibleParties,
          deficiency_comments: chartResponse?.DeficiencyComments
        });

        getMasterData(chartResponse?.ClientId, chartResponse?.LocationId)
          .then((response) => {
            Chartform.setget(response?.data.dispositions);
            Chartform.setaudit(response?.data.audit_options);
            Chartform.setchartstatus(response?.data?.statuses);
            Chartform.setresponsible(response?.data.responsible_parties);
            Chartform.setholdreason(response?.data.hold_reasons);
            Chartform.setauditor(response?.data.auditors_attending);
            Chartform.setDisposition(response?.data?.dispositions);
            Chartform.setMasterData(response?.data);
            setAuditors(response?.data.auditors);
          })
          .catch((error) => {
            console.log(error);
          });

        setLoadingState(false);
      } else {
        window.toastr.error(response.message);
        setLoadingState(false);
      }
    } catch (error) {
      console.log(error);
      setLoadingState(false);
    }
  };

  return (
    <>
      <EnabledContext.Provider value={enabled}>
        <div className="row mb-2">
          <div className="col-12 mb-2 d-flex justify-content-between">
            <div>
              <button
                onClick={handlePrevious}
                type="submit"
                id="previousChart"
                className="btn fw-bold btn-primary me-2"
                disabled={isLoading}
              >
                <i className="bi bi-arrow-left"></i> Previous Chart
              </button>
            </div>
            <div className="d-flex gap-4">
              {false && (auth.role === role?.Coder && chartData.ChartNo) // Incomplete Requirement - Feature on Hold
                && <button
                className="btn fw-bold btn-secondary d-flex align-items-center gap-2"
                onClick={() => setShowShareForReviewModal(true)}
              >
                Share for Review
                <i className="fa fa-share" />
              </button>}
              <button
                onClick={handleNext}
                type="submit"
                id="nextChart"
                className="btn fw-bold btn-primary"
                disabled={isLoading}
              >
                Next Chart <i className="bi bi-arrow-right"></i>
              </button>
            </div>
          </div>
        </div>
        {isLoading && (
          <>
            <span className="search-spinner position-absolute top-50 translate-middle-y end-50">
              <span className="spinner-border h-50px w-50px align-middle text-gray-400" />
            </span>
          </>
        )}
        {!isLoading && (
          <div className="row">
            <div className="col-xl-9 col-12"></div>
            <div className="col-xl-8 col-lg-12 col-md-12">
              <div className="row">
                <div className="col-xl-9 col-12">
                  <NewChart
                    data={chartData}
                    reRenderChart={reRenderChart}
                    onReRenderChart={setReRenderChart}
                  />
                </div>
                <Timer
                  enabled={enabled}
                  clientData={chartData?.Status}
                  enableUserEdit={enableUserEdit}
                  onEnable={setEnabled}
                  existingTimer={chartData?.timer}
                  onReRenderTimer={setReRenderTimer}
                />
              </div>
              {/*begin::Row*/}
              <div className="row gy-5 g-xl-10">
                {/*begin::Col*/}
                <ChartForm
                  enabled={enabled}
                  clientData={chartData}
                  data={Chartform}
                  onSubmit={showLogin}
                  onReRenderChart={setReRenderChart}
                  getChartDetails={getChartDetails}
                  reRenderTimer={reRenderTimer}
                  onReRenderTimer={setReRenderTimer}
                />
                {/*end::Col*/}
              </div>
              {/*end::Row*/}
            </div>
            <div className="col-xl-4 col-lg-12 col-md-12">
              <div className="row">
                <ChartUsers data={chartData} />
                <ChartComments
                  data={chartData}
                  enabled={
                    enabled &&
                    (auth.role === role?.Coder ||
                      auth.role === role?.Auditor ||
                      auth.role === role?.Manager ||
                      auth.role === role?.TeamLead)
                  }
                />
                <TimeTracker />
                <ActivityLogs />
              </div>
            </div>
          </div>
        )}
        {auth.role === role?.Coder
          && (<ShareForReviewModal
            onHide={handleHideShareForReviewModal}
            show={showShareForReviewModal}
            auditors={auditors}
          />)}
      </EnabledContext.Provider>
    </>
  );
}
export default ChartDetails;
